"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSportItemDto = instanceOfSportItemDto;
exports.SportItemDtoFromJSON = SportItemDtoFromJSON;
exports.SportItemDtoFromJSONTyped = SportItemDtoFromJSONTyped;
exports.SportItemDtoToJSON = SportItemDtoToJSON;
exports.SportItemDtoToJSONTyped = SportItemDtoToJSONTyped;
/**
 * Check if a given object implements the SportItemDto interface.
 */
function instanceOfSportItemDto(value) {
    if (!('sportId' in value) || value['sportId'] === undefined)
        return false;
    if (!('sportCode' in value) || value['sportCode'] === undefined)
        return false;
    if (!('sportName' in value) || value['sportName'] === undefined)
        return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined)
        return false;
    return true;
}
function SportItemDtoFromJSON(json) {
    return SportItemDtoFromJSONTyped(json, false);
}
function SportItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportId': json['sportId'],
        'sportCode': json['sportCode'],
        'sportName': json['sportName'],
        'isEnabled': json['isEnabled'],
    };
}
function SportItemDtoToJSON(json) {
    return SportItemDtoToJSONTyped(json, false);
}
function SportItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportId': value['sportId'],
        'sportCode': value['sportCode'],
        'sportName': value['sportName'],
        'isEnabled': value['isEnabled'],
    };
}
